import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Store } from 'components/common/types/Store.types';
import EditableChip from 'lib/EditableChip';
import { PlannerSecondaryPanelType } from 'store/dealManagement/types';
import { useOnChangePanelVisibility } from 'components/pages/Planner/hooks/useOnChangePanelVisibility';
import { DealStatus } from 'components/common/types/Deal.types';
import { CampaignBookingStatusPanel } from './CampaignBookingStatusPanel';
import { bookingStatusStyles, defaultBookingStatusStyle } from '../../../../ChipBookingStatus/consts';
import { getCampaignBookingStatusOptions } from './utils';

interface CampaignBookingStatusProps {
  onConfirm: (status: DealStatus) => void;
}

const CampaignBookingStatus: React.FC<CampaignBookingStatusProps> = ({ onConfirm }) => {
  const bookingStatus = useSelector((state: Store) => state.dealManagement.commonDeal.bookingStatusCode);
  const plannerSecondaryPanelType = useSelector((state: Store) => state.dealManagement.plannerSecondaryPanelType);

  const onChangePanelVisibility = useOnChangePanelVisibility();

  const isStatusPanelOpen = plannerSecondaryPanelType === PlannerSecondaryPanelType.PROGRAMMATIC_STATUS;
  const styles = bookingStatusStyles[bookingStatus] ?? defaultBookingStatusStyle;

  const statusOptions = getCampaignBookingStatusOptions();
  const isDisabled = useMemo(() => statusOptions.every(({ isVisible }) => !isVisible), [statusOptions]);

  return (
    <>
      <EditableChip
        buttonLabel="Update status"
        chipLabel={styles.text}
        chipColor={styles.style}
        dataTestId="campaign-booking-status"
        isActive={isStatusPanelOpen}
        isDisabled={isDisabled}
        onClick={() => onChangePanelVisibility(PlannerSecondaryPanelType.PROGRAMMATIC_STATUS)}
      />
      {isStatusPanelOpen && <CampaignBookingStatusPanel onConfirm={onConfirm} statusOptions={statusOptions} />}
    </>
  );
};

export default CampaignBookingStatus;
